import { useSyncExternalStore } from 'react';

const KEY = `darkMode`;
const listeners = new Set<() => void>();

function readStored(): boolean {
  try {
    return localStorage.getItem(KEY) === `true`;
  }
  catch {
    return false;
  }
}

// In-memory source of truth - localStorage is only persistence, so toggling
// still works when storage is unavailable (private mode etc.)
let current = readStored();

export function isDarkMode(): boolean {
  return current;
}

function apply() {
  document.documentElement.classList.toggle(`dark`, current);
}

export function setDarkMode(value: boolean) {
  current = value;

  try {
    localStorage.setItem(KEY, String(value));
  }
  catch { /* not persisted - keeps working for this page load */ }

  apply();
  listeners.forEach(l => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);

  return () => listeners.delete(listener);
}

export function useDarkMode() {
  return useSyncExternalStore(subscribe, isDarkMode);
}

// Apply persisted preference on load
apply();
